import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const AnomalyIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M3.36364 3.36364V9.72727H9.72727V3.36364H3.36364ZM2.90909 2C2.40701 2 2 2.40701 2 2.90909V10.1818C2 10.6839 2.40701 11.0909 2.90909 11.0909H10.1818C10.6839 11.0909 11.0909 10.6839 11.0909 10.1818V2.90909C11.0909 2.40701 10.6839 2 10.1818 2H2.90909Z'
    fill='#0058AD'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M3.36364 14.2727V20.6364H9.72727V14.2727H3.36364ZM2.90909 12.9091C2.40701 12.9091 2 13.3161 2 13.8182V21.0909C2 21.593 2.40701 22 2.90909 22H10.1818C10.6839 22 11.0909 21.593 11.0909 21.0909V13.8182C11.0909 13.3161 10.6839 12.9091 10.1818 12.9091H2.90909Z'
    fill='#0058AD'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M14.2727 17.4545C14.2727 19.2118 15.6973 20.6364 17.4545 20.6364C19.2118 20.6364 20.6364 19.2118 20.6364 17.4545C20.6364 15.6973 19.2118 14.2727 17.4545 14.2727C15.6973 14.2727 14.2727 15.6973 14.2727 17.4545ZM17.4545 12.9091C14.9442 12.9091 12.9091 14.9442 12.9091 17.4545C12.9091 19.9649 14.9442 22 17.4545 22C19.9649 22 22 19.9649 22 17.4545C22 14.9442 19.9649 12.9091 17.4545 12.9091Z'
    fill='#0058AD'
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M14.2727 3.36364V9.72727H20.6364V3.36364H14.2727ZM13.8182 2C13.3161 2 12.9091 2.40701 12.9091 2.90909V10.1818C12.9091 10.6839 13.3161 11.0909 13.8182 11.0909H21.0909C21.593 11.0909 22 10.6839 22 10.1818V2.90909C22 2.40701 21.593 2 21.0909 2H13.8182Z'
    fill='#0058AD'
  />
</Svg>;

export default AnomalyIcon;
